import { useContext } from "react";
import { FormContext } from "../formContext";
import { defaultHeaderTitleText } from "../constants";
import { useSetWithDismountFallback } from "@hooks/useSetWithDismountFallback";
import { emptySetterFunction } from "@utils/helpers/emptyFunction";

// note: if this hook doesnt finish firing (why wouldnt it??) we could have race condition issues
// with mounting pages. There must never be more than 1 consumer of this hook in the react virtual
// dom at any time
export const useSetTitle = (headerTitle, enabled = true) => {
  const { header: {setTitle} } = useContext(FormContext);
  useSetWithDismountFallback(enabled ? setTitle : emptySetterFunction, defaultHeaderTitleText, headerTitle);
};